import styled from 'styled-components';

import { Modal } from '@useblu/ocean-react';

import {
  colorBrandPrimaryPure,
  colorInterfaceDarkDeep,
  colorInterfaceDarkDown,
  fontFamilyHighlight,
  fontFamilyBase,
  fontSizeSm,
  fontSizeXxs,
  spacingInsetMd,
  spacingInlineXxs,
  fontWeightExtrabold,
  fontWeightRegular,
} from '@useblu/ocean-tokens/web/tokens';

import { breakpointTo, bpMedium } from 'tokens';

export const CustomModal = styled(Modal)`
  &&& {
    width: 347px;
    height: 240px;
    background: white;
    margin: auto;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    outline: none;
    border-radius: 16px;

    .ods-modal__header {
      display: none;
    }

    .ods-modal__body {
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      height: 100%;
    }

    @media ${breakpointTo(bpMedium)} {
      width: 100%;
      height: 100%;
      border-radius: 0px;

      .ods-modal__header {
        display: block;
      }

      .ods-modal__header-close {
        display: block;
        margin-left: 0px;
        color: ${colorBrandPrimaryPure};
      }

      .ods-modal__body {
        height: 100%;
        margin-top: -60px;
      }
    }
  }
`;

export const ModalTitle = styled.h3`
  font-family: ${fontFamilyHighlight};
  margin: 0px;
  margin-top: ${spacingInsetMd};
  width: 100%;
  color: ${colorInterfaceDarkDeep};
  text-align: center;
  font-size: ${fontSizeSm};
  font-weight: ${fontWeightExtrabold};

  @media ${breakpointTo(bpMedium)} {
    color: ${colorBrandPrimaryPure};
  }
`;

export const ModalSubtitle = styled.p`
  font-family: ${fontFamilyBase};
  margin: 0px;
  margin-top: ${spacingInlineXxs};
  width: 100%;
  color: ${colorInterfaceDarkDown};
  text-align: center;
  font-size: ${fontSizeXxs};
  font-weight: ${fontWeightRegular};
`;
